module.exports = __webpack_public_path__ + "img/pen-swirl.7fb34608.svg";